export default class CitySelectorController {
  static $inject = [];

  constructor() {}
}
